module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAvUlEQVQ4T7WUUQ6CQAxEp95qPyQa9RzgzfAcmmj0g1u5ZkkwJZROPxb+yE7ezrTdCip/UpmH7YH3z3C47NMr4tzSzhwWwQ54IqM/NenqQR/voRdB+wWO2sAi8iT0oJMmZ9zOTer0xWYNPagHK+DVplhQBnOB5VBDx1iCzopJI2vBHwqAwajDmcvyE+i+O9i6ZuPtgpZBaVN0zMhIuWNj1YxBVwfba4AHNZ9epJvhp1d1OUQ2DNNsvw+ZA3b+A/RulhXEbTcqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/close.png
// module id = 200
// module chunks = 0